import * as yup from 'yup';

export const CommunicationDataSchema = yup.object({
  phone: yup.string().notRequired().nullable(),
  mobilePhone: yup.string().notRequired().nullable(),
  email: yup.string().notRequired().nullable(),
});
export const UpdateCommunicationDataSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(CommunicationDataSchema);

export interface ICommunicationData {
  phone?: string;
  mobilePhone?: string;
  email?: string;
}

export interface IUpdateCommunicationData extends ICommunicationData {
  id: string;
}
